import { getPostPurchaseRedirect } from "./postPurchaseRedirect";
import {
  UPSELL_V2_ENTRY_ROUTES,
  UPSELL_V2_PRODUCTS,
  UPSELL_V2_SEQUENCES,
} from "../constants/upsellsV2";
const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
export const getUpsellV2Funnel = (pathname) =>
  own(UPSELL_V2_ENTRY_ROUTES, pathname)
    ? UPSELL_V2_ENTRY_ROUTES[pathname]
    : null;
export function getUpsellV2Offer(productKey, currency) {
  if (
    !own(UPSELL_V2_PRODUCTS, productKey) ||
    !["usd", "eur"].includes(currency)
  )
    return null;
  return {
    ...UPSELL_V2_PRODUCTS[productKey],
    productKey,
    currency,
    offerId: `upsell-v2-${productKey}-${currency}`,
    amount: 299,
    oldAmount: 799,
    discountPercent: Math.round((1 - 299 / 799) * 100),
  };
}
export function getUpsellV2Target(session, redirectLink, fallbackSearch = "") {
  const sequence =
    session &&
    own(UPSELL_V2_SEQUENCES, session.funnel) &&
    UPSELL_V2_SEQUENCES[session.funnel];
  const product = sequence?.[session.currentStep];
  return product
    ? UPSELL_V2_PRODUCTS[product].route + (session.search || "")
    : getPostPurchaseRedirect(redirectLink, session?.search ?? fallbackSearch);
}
export function preserveUpsellV2Search(search = "") {
  const params = new URLSearchParams(search);
  // Keep attribution, photos and arbitrary quiz context; payment data stays out of URLs.
  for (const key of Array.from(params.keys())) {
    if (
      /secret|token|password|authorization|customer.?id|payment.?method|payment.?intent|stripe/i.test(
        key,
      )
    )
      params.delete(key);
  }
  const value = params.toString();
  return value ? `?${value}` : "";
}
